import DefaultProfile from '../components/DefaultProfile/DefaultProfile';
import EventTypeComponent from '../../shared/components/EventTypes/EventTypeComponent';
import NewUserForm from '../components/NewUserForm/NewUserForm';
import NotificationMap from '../../shared/components/NotificationMap/NotificationMap';
import ConfirmationScreen from '../components/ConfirmationScreen';
import { StepperComponentProps } from '../types';
import { TimeSpans } from '../../shared/components';

export const steps: ReadonlyArray<{
  label: string;
  description: string;
  component: React.ComponentType<StepperComponentProps>;
}> = [
  {
    label: 'Enter Account Information',
    description: `Please enter your account information. This includes your name, email address,
                and password. This information will be used to create your account.`,
    component: NewUserForm,
  },
  {
    label: 'Start Default Profile',
    description: `An email notification profile is a set of notification times, regions,
          and types of events which are used to determine what events a user
          will receive emails about. Once your account and default profile are
          created, you will be able to set up additional customized profiles.`,
    component: DefaultProfile,
  },
  {
    label: 'When do you want to receive notifications?',
    description: `Define times during the day when you would want to receive email notifications of traffic incidents. 
      You may create multiple alert periods, but at least one must be defined in order to receive notifications.`,
    component: TimeSpans,
  },
  {
    label: 'What types of notifications would you like to receive?',
    description: `Select the event types and impact levels for which you want to receive alerts.`,
    component: EventTypeComponent,
  },
  {
    label: 'What areas would you like to receive notifications for?',
    description: `Define areas for which you would like to receive notifications.
        You may create up to 15 areas, but at least one must be defined in order to receive notifications.`,
    component: NotificationMap,
  },
  {
    label: 'Configuration Complete',
    description: `Initial Configuration of your email notification profile is complete.`,
    component: ConfirmationScreen,
  },
];
